module.exports = __webpack_public_path__ + "static/media/pexels-logo-black.d561cb7d.png";